import { HttpErrorResponse } from "@angular/common/http";
import { GroupEditResult, GroupList } from "src/app/_models/Group";

export interface EditGroupState {
  loading: boolean;
  group: GroupList;
  error: HttpErrorResponse;
  result: GroupEditResult;
}

export const initialEditGroupState: EditGroupState = {
  loading: false,
  group: null,
  error: null,
  result: null,
}